import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import DistanceEducation from './section-components/distance-education';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const distanceEducation = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>#1 Guidance Program for Distance Education and Architecture Chennai</title>
            <meta name="description" content="MIET provides guidance programs for engineering and architecture aspirants. Our aim is to equip the students with the necessary knowledge and skill-sets." />
        </Helmet>
        <PageHeader headertitle="Distance Education"  />
        <DistanceEducation />
        <Footer />
    </div>
}

export default distanceEducation